/**
 * Catálogo do domínio `obra` (T53, CAT-02).
 *
 * Origem: `src/shared/autorizacao/obra.ts`. Nenhum comportamento novo — o que
 * está aqui é o que aquele arquivo já concede, escrito como dado.
 */
import type { Concessao, NomePapel, Papel } from "../catalogo/vocabulario";

/**
 * O que qualquer usuário autenticado recebe no domínio, sem papel nenhum.
 *
 * `obra.ts:8-9` concede `read` e `seeAll` em `Obra` dentro do `if (user)`, antes
 * de qualquer `temPermissao`. Não é papel e não tem como virar um sem tirar
 * acesso de quem tem hoje — então é concessão de base, e a T54 a compõe junto
 * dos papéis.
 */
export const CONCESSOES_BASE_OBRA: readonly Concessao[] = [
  { acoes: ["read", "seeAll"], recurso: "Obra" },
];

export const PAPEIS_OBRA = {
  "obra.admin": {
    dominio: "obra",
    nivel: "admin",
    concessoes: [{ acoes: ["manage"], recurso: "Obra" }],
  },
  "obra.escrita": {
    dominio: "obra",
    nivel: "escrita",
    concessoes: [{ acoes: ["create", "update", "delete", "inspect"], recurso: "Obra" }],
  },
  /**
   * Nenhuma chave de `LEGADO` aponta para cá: hoje a leitura de `Obra` vem da
   * base acima, para todo mundo. O papel existe porque `GRUPOS.CLIENTE_LEITOR`,
   * `GRUPOS.CLIENTE_APROVADOR` e `GRUPOS.MKT` o citam — e porque é ele que
   * sobra quando a leitura deixar de ser universal (T59/T60, escopo).
   */
  "obra.leitura": {
    dominio: "obra",
    nivel: "leitura",
    concessoes: [{ acoes: ["read"], recurso: "Obra" }],
  },
} as const satisfies Partial<Record<NomePapel, Papel>>;
